export const APP_ACTIVITY_MAX_SPAN_MS = 60_000;
export const APP_ACTIVITY_MAX_CLOCK_SKEW_MS = 5 * 60_000;
export const APP_ACTIVITY_DAILY_LIMIT = 6_000;
export function isAppActivityInterval(value) {
    if (!value || typeof value !== "object" || Array.isArray(value))
        return false;
    const item = value;
    if (Object.keys(item).length !== 3 ||
        typeof item.eventId !== "string" ||
        !/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(item.eventId) ||
        typeof item.firstOccurredAt !== "string" ||
        typeof item.lastOccurredAt !== "string")
        return false;
    const first = Date.parse(item.firstOccurredAt);
    const last = Date.parse(item.lastOccurredAt);
    return (Number.isFinite(first) &&
        Number.isFinite(last) &&
        new Date(first).toISOString() === item.firstOccurredAt &&
        new Date(last).toISOString() === item.lastOccurredAt &&
        last >= first &&
        last - first <= APP_ACTIVITY_MAX_SPAN_MS &&
        item.firstOccurredAt.slice(0, 10) === item.lastOccurredAt.slice(0, 10));
}
//# sourceMappingURL=appActivity.js.map